import { observable, action, computed } from 'mobx'
import Parse from 'parse'
import _ from 'lodash'

class PartnersStore {

    @observable partners
    @observable allPartners
    @observable partner
    @observable partnerMembers
    @observable contracts
    @observable invoices
    @observable loading
    @observable partnersWithSpecialContract

    constructor() {
        this.loading = false
        this.partners = null
        this.allPartners = null
        this.partner = null
        this.partnerMembers = null
        this.contracts = null
        this.invoices = null
        this.partnersWithSpecialContract = []
    }

    @computed get isLoading() {
        return this.loading ? true : false
    }

    @computed get arePartnersSet() {
        return this.partners && this.partners[0] ? true : false
    }

    @computed get isPartnerSet() {
        return this.partner && ((this.partner.name && this.partnerMembers) || (this.partner.objectId === "")) ? true : false
    }

    @action setPartners = (partners) => {
        this.partners = partners
    }

    @action setLoading = (loading) => {
        this.loading = loading
    }

    @action setAllPartners = (partners) => {
        this.allPartners = partners
    }

    @action setPartner = (partner) => {
        this.partner = partner
    }

    @action setMembers = (members) => {
        this.partnerMembers = members
    }

    @action setContracts = (contracts) => {
        this.contracts = contracts
    }

    @action setInvoices = (invoices) => {
        this.invoices = invoices
    }

    getPartner = (shortname) => {
        let companyQuery = new Parse.Query("Company")
        let userQuery = new Parse.Query("User")

        companyQuery.equalTo("shortname", shortname)
        companyQuery.first().then(result => {
            const company = result.toJSON()
            this.setPartner(company)

            let membersTemp = []
            userQuery.equalTo("company", result);
            userQuery.each(member => {
                membersTemp.push(member.toJSON())
            }).then(res => {
                this.setMembers(membersTemp)
            }).catch(error => {
                console.error("error", error)
            })
        }).catch(err => {
            console.error("user-err", err)
        })
    }

    getPartnerByID = async (cid) => {
        this.setPartner(null)
        this.setMembers(null)

        if (cid === "new") {
            const config = await Parse.Config.get()
            this.setPartner({
                objectId: "",
                industry: "",
                shortname: "",
                logo: "",
                name: "",
                // vat: 0.2,
                isSpecial: false,
                sortingNumber: undefined,
                postcode: undefined,
                phone: "",
                isHidden: false,
                isExternal: false,
                location: "",
                billingAddress: "",
                uidNumber: "",
                website: "",
                email: "",
                coins: config.get("DEFAULT_COINS"),
                maxBookingCount: 120,
                maxRemainingStockBookingCount: 0,
                street: "",
                region: "wien",
                members: [],
                role: "standardUser",
            })
            return
        }

        let companyQuery = new Parse.Query("Company")
        let userQuery = new Parse.Query("User")
        let contractQuery = new Parse.Query("Contract")

        let membersTemp = [], contractsTemp = [], invoicesTemp = []
        let role

        Parse.Cloud.run('getCompanyRoleById', { companyId: cid }).then(res => {

          role = res
          companyQuery.equalTo("objectId", cid).include('region.country.*')
          return companyQuery.first()
        }).then(result => {
          const company = result.toJSON()
          console.log(company);
          company.role = role
          this.setPartner(company)

          userQuery.equalTo("company", result);
          contractQuery.equalTo("company", result);

          return userQuery.each(member => {
              membersTemp.push(member.toJSON())
          })
        }).then(res => {
          this.setMembers(membersTemp)

          return contractQuery.each(contract => {
            contractsTemp.push(contract.toJSON())
          })
        }).then(async res => {
          this.setContracts(contractsTemp)

          for(const contractObj of contractsTemp) {

            let contract = await (new Parse.Query("Contract")).get(contractObj.objectId)
            let invoiceQuery = new Parse.Query("Invoice")
            invoiceQuery.equalTo("contract", contract)
            await invoiceQuery.each(invoice => {
              invoicesTemp.push(invoice.toJSON())
            })
          }

          return

        }).then(res => {
          this.setInvoices(invoicesTemp)
        }).catch(err => {
            console.error("user-err", err)
        })
    }

    listPartners = async () => {
        if(this.partners && this.partners.length > 0) return

        this.loading = true
        let companyQuery = new Parse.Query("Company")

        const config = await Parse.Config.get()
        const graveyard = config.get("GRAVEYARD_COMPANY") && await (new Parse.Query("Company")).equalTo("objectId", config.get("GRAVEYARD_COMPANY")).first()

        let companiesTemp = []
        let companiesTempParseObjs = []
        let companiesAllTemp = []
        return companyQuery.notEqualTo('objectId', graveyard && graveyard.id).include("region").each(result => {
            companiesAllTemp.push(result.toJSON())
            if (result.toJSON().isHidden !== true) {
              companiesTempParseObjs.push(result)
              companiesTemp.push(result.toJSON())
            }
        }).then(() => {
            companiesTemp = _.sortBy(companiesTemp, 'sortingNumber')
            this.setPartners(companiesTemp)
            this.setAllPartners(companiesAllTemp)
            this.setLoading(false)
        })
        // .then(() =>
        //   Parse.Cloud.run('getLastValidContractForCompanies', { companies: companiesTemp.map(item => item.objectId) })
        // )
        // .then(async () => {
        //   // FOR LOADING CONTRACT INFOS

        //   const promises = []

        //   for(const company of companiesTempParseObjs) {
        //     const contractQuery = new Parse.Query("Contract")

        //     promises.push(
        //       contractQuery
        //         .equalTo("isAccepted", true)
        //         .notEqualTo("isArchived", true)
        //         .equalTo("company", company)
        //         .descending("year")
        //         .include("company")
        //         .first()
        //     )
        //   }

        //   const contractData = await Promise.all( promises )

        //   // await contractData.forEach(async (item, i) => {
        //   //   if(!item || item.get("fee") == 2100 || !item.get("company")) return
        //   //   const companydata = companiesTemp.find(company => company.objectId === item.get("company").id)
        //   //   const role = await Parse.Cloud.run('getCompanyRoleById', { companyId: item.get("company").id })
        //   //
        //   //   partnersWithSpecialContract.push({
        //   //     ...companydata,
        //   //     contract_fee: item.get("fee") + " €",
        //   //     contract_url: item.get("url"),
        //   //     contract_year: item.get("year"),
        //   //     role: role,
        //   //   })
        //   // })


        //   const partnersWithSpecialContract = await Promise.all(contractData.filter(item => item).map(async (item)  => {
        //     if(!item || item.get("fee") == 2100 || !item.get("company")) return

        //     const companydata = companiesTemp.find(company => company && company.objectId === item.get("company").id)

        //     const role = await Parse.Cloud.run('getCompanyRoleById', { companyId: item.get("company").id })

        //     if(role === "premiumUser" && item.get("fee") === 4200) return

        //     return {
        //       ...companydata,
        //       contract_fee: item.get("fee") + " €",
        //       contract_url: item.get("url"),
        //       contract_year: item.get("year"),
        //       role: role,
        //     }
        //   }));

        //   this.partnersWithSpecialContract = partnersWithSpecialContract.filter(item => item)

        // })
        .catch(err => {
            this.loading = false
            console.error("listPartners-err", err)
        })
    }

}

const store = new PartnersStore()
export default store



// WEBPACK FOOTER //
// /src/stores/PartnersStore.js